import type { EntityConfig } from "@/v2/framework/registry/types";
import { createTeamsView } from "./grid/view";

export default {
  id: "teams",
  name: "teams",
  title: "metadata.teams",
  position: 7,
  create: (ctx) => createTeamsView(ctx),
} satisfies EntityConfig;
